import classNames from 'classnames';
import { useCallback } from 'react';
import { useModal } from 'yoso';
import { AdventureReward } from '~/components/Adventure/Adventure.hooks';
import { AdventureRewardHeading } from '~/components/Adventure/Card/AdventureRewardHeading';
import { BaseCard } from '~/components/Card/Base/BaseCard';
import { Content } from '~/components/Content';
import { T } from '~/components/I18n';
import { ContentViewer } from '~/components/Viewer/ContentViewer';
import styles from './AdventureCard.module.scss';

export type AdventureCardProps = AdventureReward & {
  className?: string;
  variant?: 'small' | 'medium' | 'large';
};

export const AdventureCard = ({ className, variant = 'medium', ...reward }: AdventureCardProps) => {
  const { originContentsUrl, contentsType, contentsUrl } = reward;
  const { open } = useModal({ componentName: 'full' });

  const onClick = useCallback(async () => {
    await open(
      <ContentViewer
        contentsType={contentsType}
        contentsUrl={contentsUrl}
        originContentsUrl={originContentsUrl}
        footer={<AdventureRewardHeading {...reward} />}
      />
    );
  }, [open, contentsType, contentsUrl, originContentsUrl, reward]);

  return (
    <BaseCard
      className={classNames(styles.root, styles[variant], className)}
      size="large"
      onClick={onClick}>
      <Content
        className={styles.content}
        contentsUrl={contentsUrl}
        contentsType={contentsType}
        originContentsUrl={originContentsUrl}
      />
      <div className={styles.inner}>
        <div className={styles.body}>
          <AdventureRewardHeading className={styles.heading} {...reward} />
        </div>
        <div className={styles.footer}>
          <p className={styles.count}>
            <T name="citizen_adventure_winning_num_1" options={[reward.winnerCount]} />
          </p>
        </div>
      </div>
    </BaseCard>
  );
};
